import {PANELMANAGER_ACTIVATE_PANEL} from '../../constants';
import {PanelProps} from 'primereact/panel';

export type ActivatePanelAction = {
    type : typeof PANELMANAGER_ACTIVATE_PANEL;
    panelIndexOrKey : number | string;
    historyNavigation : boolean;
    propsToSet? : PanelProps;
}

/**
 * @memberOf! Actions
 *
 * @param {number|string} panelIndexOrKey
 * @param {boolean} [historyNavigation=false]
 * @param {PanelProps} [propsToSet]
 *
 * @return {ActivatePanelAction}
 */
const activatePanel = ( panelIndexOrKey : number | string, historyNavigation : boolean = false, propsToSet? : PanelProps ) : ActivatePanelAction => {
    return {
        type: PANELMANAGER_ACTIVATE_PANEL,
        panelIndexOrKey,
        historyNavigation,
        propsToSet
    };
}
export type ActivatePanel = typeof activatePanel;

export default activatePanel;
